import type { ModalProps } from './ModalTypes';
import type * as React from 'react';

import { Modal as RNModal } from 'react-native';

export type { ModalProps } from './ModalTypes';

export function Modal({
    visible,
    onRequestClose,
    onShow,
    onDismiss,
    transparent,
    animationType,
    presentationStyle,
    statusBarTranslucent,
    supportedOrientations,
    accessible,
    accessibilityViewIsModal,
    accessibilityLabel,
    children,
    testID,
}: ModalProps): React.JSX.Element {
    return (
        <RNModal
            visible={visible}
            onRequestClose={onRequestClose}
            onShow={onShow}
            onDismiss={onDismiss}
            transparent={transparent}
            animationType={animationType}
            presentationStyle={presentationStyle}
            statusBarTranslucent={statusBarTranslucent}
            supportedOrientations={supportedOrientations}
            accessible={accessible}
            accessibilityViewIsModal={accessibilityViewIsModal}
            accessibilityLabel={accessibilityLabel}
            testID={testID}
        >
            {children}
        </RNModal>
    );
}
